/**
 * Cache Manager - Handles clearing outdated cached data
 */

const CACHE_VERSION_KEY = 'app_cache_version';
const CURRENT_CACHE_VERSION = process.env.REACT_APP_VERSION || '3.6.3';

/**
 * Check if cache needs to be cleared based on version
 */
export const checkAndClearCache = () => {
  try {
    const cachedVersion = localStorage.getItem(CACHE_VERSION_KEY);
    
    if (cachedVersion !== CURRENT_CACHE_VERSION) {
      console.log(`Cache version mismatch. Clearing cache. Old: ${cachedVersion}, New: ${CURRENT_CACHE_VERSION}`);
      clearAllCache();
      localStorage.setItem(CACHE_VERSION_KEY, CURRENT_CACHE_VERSION);
    }
  } catch (error) {
    console.error('Error checking cache version:', error);
  }
};

/**
 * Clear all browser cache (localStorage, sessionStorage)
 */
export const clearAllCache = () => {
  try {
    // Clear localStorage except version key
    const keysToPreserve = [CACHE_VERSION_KEY];
    const keys = Object.keys(localStorage);
    
    keys.forEach(key => {
      if (!keysToPreserve.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    
    // Clear sessionStorage completely
    sessionStorage.clear();
    
    console.log('Browser cache cleared successfully');
  } catch (error) {
    console.error('Error clearing cache:', error);
  }
};

/**
 * Force reload the page without cache
 */
export const forceReload = () => {
  window.location.reload(true);
};

/**
 * Clear cache and reload
 */
export const clearCacheAndReload = () => {
  clearAllCache();
  forceReload();
};

export default {
  checkAndClearCache,
  clearAllCache,
  forceReload,
  clearCacheAndReload,
  CURRENT_CACHE_VERSION
};
